import { ChatUI, sendTwillioMSG } from 'pages/Contracts/messages/chat'
import React, { useEffect, useRef, useState } from 'react'
import { Container } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import apiUrl from 'slices/apiEndpoint'
import { selectLoading, setLoading } from 'slices/contract/reducer'
import { getDecodeId, getUserName } from 'slices/userProfile/thunk'
import { Client } from "@twilio/conversations";
import axios from 'axios'
import decodeJwt from 'helpers/jwt-token-access/jwtdecode'
import api from 'Common/api'

const Chatroom = () => {
  const [searchParams]  = useSearchParams()
  const  [token,setToken] = useState("")
  const [chatClient, setChatClient] = useState<Client | null>(null);
  const [messages, setMessages] = useState<any[]>([]);
  const [messageInput, setMessageInput] = useState("");
  const [conversation, setConversation] = useState<any>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const OtherId = searchParams.get("id"); // Get the 'id' parameter
  const OtherName = searchParams.get("name"); // Get the 'id' parameter
  const userType = searchParams.get("type"); // Get the 'id' parameter
  const otherUserIdentity = `user_${OtherId}`
  const idendity = `user_${getDecodeId()}`
 const chatName ="hii"
 const loading = useSelector(selectLoading)
 const dispatch = useDispatch()
 const getChatID = (firstID:any,secondID:any) =>{
  const highestValue = Number(firstID) >Number(secondID) ?firstID:secondID
  const lowestValue = Number(firstID) <Number(secondID) ?firstID:secondID
  const chatID = `${highestValue}_${lowestValue}`
console.log(chatID)
  return chatID
}

getUserName()

  useEffect(() => {

    const fetchToken = async () => {
      try {
        dispatch(setLoading(true))
        const res = await fetch(`${apiUrl}/chat/generate-token`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ identity: idendity }),
        });
        const data = await res.json();
        console.log("✅ Token received:", data.token);

        setToken(data.token);
        const client = new Client(data.token);
        setChatClient(client);

        client.on("stateChanged", async (state) => {
          console.log("🔄 Client state changed:", state);
          if (state === "initialized") {
            getOrCreateConversation(client);
          }else{
        dispatch(setLoading(false))

          }
        });
      } catch (error) {
        dispatch(setLoading(false))
        console.error("❌ Error fetching token:", error);
      }
    };

    fetchToken();
  }, []);
  const registerUserIfNeeded = async (identity: string) => {
    try {
      // 🔹 Check if the user exists via your Node.js API
      const res = await api.get(`/chat/check-user/${identity}`);
  
      if (res.data.registered) {
        console.log(`🟢 User exists in Twilio: ${identity}`);
      } else {
        console.log(`🟡 User not found. Registering: ${identity}`);
  
        // 🔹 Register user via your Node.js API
        await api.post(`/chat/register-user`, { identity });
  
        console.log(`✅ User registered: ${identity}`);
      }
    } catch (error: any) {
      console.error("❌ Error checking/registering user:", error);
    }
  };
  const chatID = getChatID(getDecodeId(),OtherId)
 
const getOrCreateConversation = async (client: Client) => {

    try {
      let convo = await client.getConversationByUniqueName(chatID).catch(async () => {
        console.log("❌ No existing conversation found, creating a new one...");
const friendlyName = `${getDecodeId()}-${getUserName()}_${OtherId}-${OtherName}`

        const newConvo = await client.createConversation({ uniqueName: chatID, friendlyName: friendlyName  });
        console.log("🆕 New conversation created:", newConvo.sid);
        await newConvo.join();
        return newConvo;
      });

      console.log("🔄 Fetching participants...");
      const participants = await convo.getParticipants();
      console.log("👥 Current participants:", participants.map((p: any) => p.identity));

      const addUserToConversation = async (identity: string) => {
        if (!participants.some((p: any) => p.identity === identity)) {
          console.log(`🟡 Checking & registering user if needed: ${identity}`);
          await registerUserIfNeeded(identity);
          console.log(`🟡 Adding user: ${identity}`);
          await convo.add(identity);
        }
      };

      await addUserToConversation(`user_${getDecodeId()}`);
      await addUserToConversation(`user_${OtherId}`);

      console.log("✅ Participants added successfully!");
      setConversation(convo);
      loadMessages(convo);

      convo.on("messageAdded", (message: any) => {
        console.log("📩 New message received:", message.body);
       
        setMessages((prev) => [...prev, message]);
      });
    } catch (error) {
      console.error("❌ Error getting/creating conversation:", error);
    } finally{
      dispatch(setLoading(false))

    }
  };

  const loadMessages = async (convo: any) => {
    console.log("📩 Loading messages...");
    const messages = await convo.getMessages();
    console.log("✅ Messages loaded:", messages.items.length);
    setMessages(messages.items);
  };

  const sendMessage =()=>{
    sendTwillioMSG(conversation, messageInput, selectedFile, setSelectedFile, setMessageInput);
  }
  const messagesEndRef = useRef()
  return (
    <React.Fragment>
      <div className="page-content tailwind-prefix">
        <Container fluid>
<ChatUI messagesEndRef={messagesEndRef} chatName={userType} secondUserName={OtherName} identityName={idendity} loading={loading} selectedFile={selectedFile} setSelectedFile={setSelectedFile} messageInput={messageInput} setMessageInput={setMessageInput}  messages={messages} identity={idendity} sendMessage={sendMessage} />
          
        </Container>
        </div>
        </React.Fragment>
  )
}

export default Chatroom